import styled, { keyframes, css } from "styled-components";
import { Section } from "./shared";

export const AuctionBox = styled.div`
  padding: 18px;
  border-radius: 16px;
  background: #0d1220;
  border: 1px solid #1f2937;
`;

export const Led = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #00ff66;
  box-shadow: 0 0 12px #00ff66;
  animation: blink 1s infinite;
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const AuctionSidebar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100vh;
  background: #0d1220;
  border-left: 1px solid #1f2937;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(110%)")};
  transition: 0.35s ease;
  padding: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const ProductEditSidebar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100vh;
  background: #0d1220;
  border-left: 1px solid #1f2937;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(110%)")};
  transition: 0.35s ease;
  padding: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const BidSidebar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100vh;
  background: #0d1220;
  border-left: 1px solid #1f2937;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(110%)")};
  transition: 0.35s ease;
  padding: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: ${({ show }) => (show ? "block" : "none")};
`;

export const PaymentMethodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PaymentMethodOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  border-radius: 10px;
  background: ${({ selected, disabled }) =>
    disabled
      ? 'rgba(255, 255, 255, 0.03)'
      : selected
        ? 'rgba(0, 247, 210, 0.1)'
        : '#0d1220'};
  border: 1px solid ${({ selected, disabled }) =>
    disabled
      ? '#1f2937'
      : selected
        ? '#00f7d2'
        : '#1f2937'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    ${({ disabled, selected }) =>
    !disabled && !selected && `
        border-color: #5ce9ff;
        background: rgba(92, 233, 255, 0.05);
      `}
  }
`;

export const PaymentMethodLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const PaymentMethodLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PaymentMethodName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
`;

export const PaymentMethodSubtext = styled.span`
  font-size: 12px;
  color: #9ca3af;
`;

export const PaymentMethodRadio = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? '#00f7d2' : '#1f2937')};
  background: ${({ selected }) => (selected ? '#00f7d2' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ selected }) => (selected ? '#000' : 'transparent')};
  }
`;

export const ComingSoonBadge = styled.span`
  font-size: 11px;
  color: #9ca3af;
  font-style: italic;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
`;

export const DetailModal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const DetailModalContent = styled.div`
  background: #0d1220;
  border: 1px solid #1f2937;
  border-radius: 18px;
  padding: 24px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #00f7d2;
  }
`;

export const DetailSection = styled.div`
  margin-bottom: 20px;
`;

export const DetailLabel = styled.p`
  font-size: 13px;
  opacity: 0.7;
  margin: 0 0 8px 0;
  color: #9ca3af;
`;

export const DetailValue = styled.p`
  font-size: 14px;
  color: #e5e7eb;
  margin: 0;
  font-weight: ${({ bold }) => bold ? 600 : 400};
  color: ${({ highlight }) => highlight ? '#00f7d2' : '#e5e7eb'};
`;

export const TierBox = styled.div`
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 10px;
  background: ${({ active, isAboveActive }) =>
    active || isAboveActive
      ? 'rgba(34,197,94,0.15)'
      : 'rgba(255,255,255,0.05)'};
  border: 1px solid #1f2937;
  font-size: 14px;
  color: #e5e7eb;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UnlockPulse = keyframes`
  0% { transform: translateY(2px) scale(0.985); box-shadow: 0 0 0 rgba(0,247,210,0); }
  40% { transform: translateY(-2px) scale(1.015); box-shadow: 0 0 28px rgba(0,247,210,0.22); }
  100% { transform: translateY(0) scale(1); box-shadow: 0 0 0 rgba(0,247,210,0); }
`;

export const TierGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 12px;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, minmax(220px, 1fr));
  }
`;

export const TierCard = styled.div`
  padding: 14px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  border: 1px solid #1f2937;
  background: #0d1220;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  ${({ active }) =>
    active &&
    css`
      border-color: rgba(0, 247, 210, 0.6);
      background: rgba(0, 247, 210, 0.08);
      box-shadow: 0 0 22px rgba(0, 247, 210, 0.14);
    `}

  ${({ unlocked }) =>
    unlocked &&
    css`
      animation: ${UnlockPulse} 0.9s ease-out;
    `}
`;

export const UnlockChip = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  font-size: 12px;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(92, 233, 255, 0.12);
  border: 1px solid rgba(92, 233, 255, 0.35);
  color: #5ce9ff;
  font-weight: 800;
  z-index: 1;
`;

export const PulseDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  position: relative;
  flex-shrink: 0;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #22c55e;
    animation: pulse 2s ease-in-out infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0.7;
    }
    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }
`;

export const DateTimeInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  background: #111522;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;

  &::-webkit-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
    opacity: 1;
  }

  &::-moz-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
  }

  &::-webkit-datetime-edit-fields-wrapper {
    color: #e5e7eb;
  }

  &::-webkit-datetime-edit-text {
    color: #9ca3af;
    padding: 0 4px;
  }

  &::-webkit-datetime-edit-month-field,
  &::-webkit-datetime-edit-day-field,
  &::-webkit-datetime-edit-year-field,
  &::-webkit-datetime-edit-hour-field,
  &::-webkit-datetime-edit-minute-field {
    color: #e5e7eb;
  }

  &::-webkit-datetime-edit-month-field:focus,
  &::-webkit-datetime-edit-day-field:focus,
  &::-webkit-datetime-edit-year-field:focus,
  &::-webkit-datetime-edit-hour-field:focus,
  &::-webkit-datetime-edit-minute-field:focus {
    background-color: rgba(0, 247, 210, 0.2);
    color: #00f7d2;
    border-radius: 4px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  font-size: 0.75rem;
  color: #9ca3af;
`;

export const Input = styled.input`
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.75rem;
  border-radius: 0.25rem;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
  
  &::placeholder {
    color: #9ca3af;
  }
`;

export const TierInputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  align-items: stretch;
  
  input {
    flex: 1;
    min-width: 0;
  }
`;

export const AddTierButton = styled.button`
  padding: 0.75rem 1rem;
  background: ${props => props.disabled ? '#1f2937' : 'linear-gradient(to right, #00f7d2, #5ce9ff)'};
  border: ${props => props.disabled ? '1px solid #1f2937' : 'none'};
  color: ${props => props.disabled ? '#6b7280' : 'black'};
  border-radius: 0.25rem;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-weight: 500;
  font-size: 0.875rem;
  transition: opacity 0.2s;
  opacity: ${props => props.disabled ? 0.5 : 1};
  height: 100%;
  align-self: stretch;
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TierTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  
  th, td {
    padding: 0.5rem;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
  }
  
  th {
    font-weight: 600;
    color: #9ca3af;
  }
  
  button {
    background: #ff3b6b;
    border: none;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    font-size: 0.7rem;
    
    &:hover {
      opacity: 0.9;
    }
  }
`;

export const TotalPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(0, 247, 210, 0.1) 0%, rgba(92, 233, 255, 0.1) 100%);
  border: 1px solid rgba(0, 247, 210, 0.2);
  margin-top: 5px;
`;

export const TotalPriceHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  flex-wrap: wrap;
`;

export const TotalPriceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const TotalPriceLabel = styled.div`
  font-size: 12px;
  color: #9ca3af;
  opacity: 0.8;
`;

export const TotalPriceValue = styled.div`
  font-size: 18px;
  color: #00f7d2;
  font-weight: 700;
  letter-spacing: 0.3px;
  word-break: break-word;
`;

export const BreakdownSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid #1f2937;
`;

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #9ca3af;
  gap: 12px;
`;

export const BreakdownLabel = styled.span`
  flex-shrink: 0;
`;

export const BreakdownValue = styled.span`
  text-align: right;
  word-break: break-word;
  flex-shrink: 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #e5e7eb;
  font-weight: 600;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #1f2937;
  gap: 12px;
`;

export const TotalLabel = styled.span`
  flex-shrink: 0;
`;

export const TotalValue = styled.span`
  color: #00f7d2;
  text-align: right;
  word-break: break-word;
  flex-shrink: 0;
`;

export const CalculationBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(0, 247, 210, 0.05);
  border: 1px solid rgba(0, 247, 210, 0.15);
`;

export const CalculationText = styled.span`
  font-size: ${props => props.size || '13px'};
  color: ${props => props.color || '#9ca3af'};
  margin-left: ${props => props.marginLeft || '0'};
`;

export const SelectWrapper = styled.div`
  width: 100%;
  
  /* Target react-select control */
  .selectDropdpenReact > div {
    background-color: #0d1220 !important;
    border: 1px solid #1f2937 !important;
    min-height: auto;
    height: auto;
    
    &:hover {
      border-color: #5ce9ff !important;
      background-color: #0d1220 !important;
    }
  }
  
  /* Target all possible react-select control classes */
  [class*="control"] {
    background-color: #0d1220 !important;
    border: 1px solid #1f2937 !important;
    
    &:hover {
      border-color: #5ce9ff !important;
      background-color: #0d1220 !important;
    }
  }
  
  /* Target single value */
  [class*="singleValue"] {
    color: #e5e7eb !important;
  }
  
  /* Target placeholder */
  [class*="placeholder"] {
    color: #9ca3af !important;
  }
  
  /* Target indicators */
  [class*="indicator"] {
    color: #e5e7eb !important;
    svg {
      fill: #e5e7eb !important;
    }
  }
`;

export const UserIdCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
`;

export const UserAvatarPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.1);
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
`;

export const UserName = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmail = styled.span`
  font-size: 0.75rem;
  color: #5ce9ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* ==========================
   GALLERY PRO (V5) STYLES
========================== */
export const GallerySection = styled(Section)`
  overflow: hidden;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 110px;
  gap: 14px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const MainStage = styled.div`
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 247, 210, 0.25);
  background: radial-gradient(900px 240px at 10% 0%, rgba(0, 247, 210, 0.18), transparent 55%),
    linear-gradient(180deg, rgba(13, 18, 32, 0.92), rgba(13, 18, 32, 0.75));
  box-shadow: 0 0 22px rgba(0, 247, 210, 0.12);
`;

export const MainStageInner = styled.button`
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: zoom-in;
  display: block;
`;

export const MainImage = styled.img`
  width: 100%;
  height: 380px;
  object-fit: cover;
  display: block;

  @media (max-width: 900px) {
    height: 320px;
  }
`;

export const StageTopRow = styled.div`
  position: absolute;
  left: 12px;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  pointer-events: none;
`;

export const StageChip = styled.div`
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(31, 41, 55, 0.95);
  background: rgba(11, 14, 20, 0.55);
  color: #e5e7eb;
  backdrop-filter: blur(8px);
`;

export const ChipDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00f7d2;
  box-shadow: 0 0 10px rgba(0, 247, 210, 0.55);
`;

export const StageActions = styled.div`
  pointer-events: auto;
  display: flex;
  gap: 8px;
`;

export const IconBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid #1f2937;
  background: rgba(13, 18, 32, 0.55);
  color: #e5e7eb;
  cursor: pointer;
  font-weight: 900;
  box-shadow: 0 0 0 rgba(0, 247, 210, 0);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 0 18px rgba(0, 247, 210, 0.14);
  }
`;

export const ThumbsRail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 380px;
  overflow: auto;
  padding-right: 2px;

  @media (max-width: 900px) {
    flex-direction: row;
    max-height: none;
    overflow: auto;
    padding-right: 0;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(31, 41, 55, 0.9);
    border-radius: 999px;
  }
`;

export const ThumbBtn = styled.button`
  width: 96px;
  height: 72px;
  border-radius: 14px;
  border: 1px solid #1f2937;
  padding: 0;
  background: #0d1220;
  overflow: hidden;
  cursor: pointer;
  opacity: ${({ active }) => (active ? 1 : 0.92)};
  transition: transform 0.15s ease, opacity 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  border-color: ${({ active }) => (active ? 'rgba(0, 247, 210, 0.55)' : '#1f2937')};
  box-shadow: ${({ active }) => (active ? '0 0 18px rgba(0, 247, 210, 0.14)' : 'none')};

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
  }
`;

export const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.86);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const LightboxFrame = styled.div`
  width: min(1100px, 92vw);
  height: min(720px, 86vh);
  border-radius: 18px;
  border: 1px solid rgba(31, 41, 55, 0.95);
  background: radial-gradient(900px 240px at 10% 0%, rgba(0, 247, 210, 0.12), transparent 55%),
    rgba(13, 18, 32, 0.92);
  box-shadow: 0 0 32px rgba(0, 247, 210, 0.12);
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

export const LbTop = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const LbTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 900;
  color: #e5e7eb;
`;

export const LbControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const LbStage = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const LbImage = styled.img`
  max-width: 92%;
  max-height: 92%;
  border-radius: 16px;
  user-select: none;
  -webkit-user-drag: none;
`;

export const LbArrow = styled.button`
  position: absolute;
  top: 50%;
  ${({ side }) => (side === 'l' ? 'left: 12px;' : 'right: 12px;')}
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 14px;
  border: 1px solid #1f2937;
  background: rgba(11, 14, 20, 0.55);
  color: #e5e7eb;
  cursor: pointer;
  font-weight: 900;
  box-shadow: 0 0 18px rgba(0, 247, 210, 0.1);
`;

export const LbThumbs = styled.div`
  padding: 12px;
  display: flex;
  gap: 10px;
  overflow: auto;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(31, 41, 55, 0.9);
    border-radius: 999px;
  }
`;

export const PurchaseDescCard = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(92, 233, 255, 0.22);
  background: radial-gradient(1200px 180px at 10% 0%, rgba(0, 247, 210, 0.12), transparent 55%),
    linear-gradient(180deg, rgba(13, 18, 32, 0.92), rgba(13, 18, 32, 0.72));
  padding: 12px 14px;
  box-shadow: inset 0 0 0 1px rgba(0, 247, 210, 0.08);
`;

export const PurchaseDescLabel = styled.div`
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.78;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PurchaseDescText = styled.div`
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.45;
  color: #e5e7eb;
  opacity: 0.92;
  white-space: pre-wrap;
`;

// Confirmation Modal Styles
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: ${fadeIn} 0.2s ease;
`;

export const ModalContainer = styled.div`
  background: #0d1220;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(92, 233, 255, 0.3);
  width: 420px;
  max-width: 90vw;
  animation: ${scaleIn} 0.2s ease;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px 0;
  color: #e5e7eb;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalMessage = styled.p`
  font-size: 14px;
  color: #9ca3af;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const ModalButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  
  ${props => props.variant === 'danger' ? `
    background: linear-gradient(90deg, #ef4444, #dc2626);
    color: white;
    
    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
    
    &:active {
      transform: translateY(0);
    }
  ` : `
    background: rgba(255, 255, 255, 0.1);
    color: #e5e7eb;
    border: 1px solid rgba(255, 255, 255, 0.2);
    
    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(92, 233, 255, 0.3);
    }
  `}
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
